import "../node_modules/select2/dist/js/select2";

$(() => {
    $("select.multi-select").select2({
        placeholder: "",
        closeOnSelect: false,
    });

    $(".resource-search .form-group").each(function () {
        $(this).find(".select2-search > input").hide();
        $(this)
            .find(".select2-search")
            .append("<span>" + $(this).children("label").text() + "</span>");
    });

    $('.filter-expand .expand a').on('click', function () {
        $('.filter-wrapper').slideToggle(600);
        $(this).parent().toggleClass('active');
    });

});
